module.exports = __webpack_public_path__ + "static/media/icon-atendente-circulado.04582f93.svg";